import { createStore } from 'zustand/vanilla';

/**
 * This store exists to make the Auth0 access token available outside of React contexts
 * (e.g. compose-app effects, navbar auth config). Once we migrate off compose-app and
 * all API calls originate from React components/hooks, this store should be removed in
 * favor of accessing the token directly via useShellAuth0().
 */

type GetAccessTokenSilently = () => Promise<string>;

interface AccessTokenStore {
  getAccessTokenSilently: GetAccessTokenSilently | undefined;
  accessToken: string | undefined;
}

export const accessTokenForNonReactContextsStore = createStore<AccessTokenStore>()(() => ({
  getAccessTokenSilently: undefined,
  accessToken: ''
}));

export async function getAccessToken(): Promise<string | undefined> {
  const { getAccessTokenSilently } = accessTokenForNonReactContextsStore.getState();
  if (!getAccessTokenSilently) {
    return undefined;
  }
  return getAccessTokenSilently();
}
